
import { useQuery } from 'react-query';
import { apiServiceRest } from 'services/api';

import { IAirport } from './types';

export const URI = () => '/airports';
export const GET_QUERY_KEY = () => 'get-airports';

export const useGetAirports = () => {
  const [apiService] = apiServiceRest<IAirport[]>();

  return useQuery(GET_QUERY_KEY(), () => apiService.get(URI()));
};

export default useGetAirports;
